let Dome2 = () => import(/* webpackChunkName: "dome" */ "@/views/_lang/dome2");
let Dome = () => import(/* webpackChunkName: "dome" */ "@/views/_lang/dome");
let Demo2 = () => import(/* webpackChunkName: "demo" */ "@/views/_lang/demo2");
export default [
  {
    path: "/:lang/dome2",
    name: "Dome2",
    component: Dome2,
    meta: { isLogin: false, level: "2,4,999" },
  },
  {
    path: "/:lang/dome",
    name: "Dome",
    component: Dome,
    meta: { isLogin: false, level: "2,4,999" },
  },
  {
    path: "/:lang/demo2",
    name: "Demo2",
    component: Demo2,
    meta: { isLogin: false, level: "2,4,999" },
  },
];
